import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { CheckIcon, LightBulbIcon, ImagesIcon, RightArrowIconThick } from 'images'
import GenerateButton from './GenerateButton'
import LoaderSpinner from 'components/Shared/Loader/LoaderSpinner'

export default function CoCreatePanelHeader(props) {
  const {
    variant,
    setVariant,
    onViewVariants,
    setSelectedSubGroupId,
    isPanelDisabled,
  } = props
  const { t } = useTranslation()

  const translationKey = `Recommendations.campaign.setup.coCreatePanel.tryCoCreate.${variant}`

  const handleClick = () => {
    if (isPanelDisabled) return

    if (variant === 'open') {
      setVariant('closed')
      setSelectedSubGroupId?.(null)
    } else if (variant === 'closed') {
      setVariant('open')
    }
  }

  // return
  return (
    <div className={`co-create-panel-header ${variant}`} onClick={handleClick}>

      <div className="co-create-description">
        <div className="co-create-icon-btn-wrapper">
          <div
            className="bt autofill_btn"
            style={{ width: 'fit-content', borderRadius: '10px' }}
            color="orange"
          >
            {variant === 'generating' ? <LoaderSpinner size="mini" style={{ padding: '2px' }}/> : <LightBulbIcon height={20} width={20} />}
          </div>

          {variant === 'ready' && (
            <span className="co-create-icon-btn__status" aria-hidden="true">
              <CheckIcon width={8} height={8} />
            </span>
          )}
        </div>

        <div>
          <p className="title">{t(`${translationKey}.title`)}</p>

          <p className="description">{t(`${translationKey}.description`)}</p>
        </div>
      </div>

      {(variant === 'closed' || variant === 'open') && (
        <RightArrowIconThick width={24} height={24} className={`arrow-icon ${variant}`}/>
      )}

      {variant === 'generating' && (
        <GenerateButton
          loading
        />
      )}

      {variant === 'ready' && (
        <button
          onClick={onViewVariants}
          type="button"
          className="view-variants-button"
        >
          <ImagesIcon width={16} height={16} />

          <span className="text">{t('Recommendations.campaign.setup.coCreatePanel.viewVariants')}</span>
        </button>
      )}
    </div>
  )
}

CoCreatePanelHeader.propTypes = {
  variant: PropTypes.oneOf(['closed', 'open', 'generating', 'ready']).isRequired,
  setVariant: PropTypes.func.isRequired,
  setSelectedSubGroupId: PropTypes.func,
  onViewVariants: PropTypes.func,
  isPanelDisabled: PropTypes.bool,
}
